import HrAssistantContainer from './HrAssistantContainer.jsx';

const HrAssistantAdmin = ({ assistantUuid, showSunsetBanner }) => (
  <HrAssistantContainer
    assistantUuid={assistantUuid}
    showSunsetBanner={showSunsetBanner}
  />
);

export default HrAssistantAdmin;
